
import { connect } from "react-redux";
import { formValueSelector } from "redux-form";
import { bindActionCreators } from "redux";
import Form from "../../components/forms/DocumentTemplateForm";
import { saveTemplate, deleteTemplate, withRedirect } from "../../CroActions";
import { decodeBase64, encodeBase64 } from "../../CroUtils";
import { breadcrumbs } from "../../../../actions/appActions";
import { noop } from "lodash";

const selector = formValueSelector("documentTemplateForm");

const mapStateToProps = (state, { params }) => ({
  breadcrumbsItems: [{ label: "Šablona dokumentu" }],
  type: selector(state, 'type'),
  templateKeys: selector(state, 'templateKeys') || [],
  isNew: false,
  url: `/spravce/api/sablony/${params.id}`,
  postProcess: (data) => ({
    ...data,
    content: data && data.content ? decodeBase64(data.content) : "",
  }),
});

const onSubmit = (values, dispatch, props) => {
  const submitValues = {
    ...values,
    content: values.content ? encodeBase64(values.content) : "",
  };
  return withRedirect(saveTemplate, "/administrator/sablony/dokument")(submitValues, dispatch, props);
};

const onDelete = (id, dispatch, props) => {
  return withRedirect(deleteTemplate, "/administrator/sablony/dokument")(id, dispatch, props);
}

const mapDispatchToProps = (dispatch, props) => ({
  ...bindActionCreators({ onSubmit, breadcrumbs }, dispatch),
  onDelete: () => dispatch(onDelete(props.params.id, dispatch, props)),
  accept: noop,
  reject: noop,
  send: noop,
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);
